import React from 'react';
import styled from 'styled-components';

import { ImainHome } from '@typings/setting/mainHome.interface';
import DdayWidget from '@template/Widget/DdayWidget';
import { masterSet } from '@masterSetting/masterSet/masterSetting';
import ServiceFooter from '@components/navigation/Footer/ServiceFooter';
import HomeNoticeSec from '../HomeNoticeSec/index';
import { useDocument } from '@nandorojo/swr-firestore';
import { CollectionPath, ImainhomeDoc } from '@typings/collections.enum';
import PageLayoutWrapper from '@app/layouts/pageLayout/PageLayout';
import { cardBorderImg } from '@styles/common/Card';
import { scrollbarHide } from '@styles/variants/scrollbar';

export const HomeGrid = styled.div<{
  isBackground?: boolean | null;
}>`
  width: 100%;
  border-radius: var(--cardBorderRadius);
  background-color: ${({ isBackground }) =>
    isBackground ? 'var(--cardBackgroundColor)' : ''};
  ${({ isBackground }) =>
    isBackground &&
    'border: var(--cardBorderWidth) var(--cardBorderType) var(--cardLineColor);'};

  isolation: isolate;
  ${({ isBackground }) => isBackground && cardBorderImg};
  overflow-y: auto;
  ${scrollbarHide}
`;

type Props = {};
function FreeType({ }: Props) {
  const { data, set } = useDocument<ImainHome>(
    `${CollectionPath.MAINHOME}/${ImainhomeDoc.MAINHOME}`,
  );
  if (!data) return null;

  return (
    <PageLayoutWrapper>
      <HomeNoticeSec showBannnerSec />
      {data && data.ddayWidgetSet && masterSet.widget?.ddayWidget && (
        <DdayWidget />
      )}

      <ServiceFooter />
    </PageLayoutWrapper>
  );
}

export default FreeType;
